import React, {PureComponent} from "react"

import {TenantOnboardingStep} from "@irati/types"

import NavSection from "./NavSection"
import {SetupSections} from "../../constants/stepConfig"

interface Props {
  customiseSteps: TenantOnboardingStep[],
  communicateSteps: TenantOnboardingStep[],
  inviteSteps: TenantOnboardingStep[]
}

class Navigation extends PureComponent<Props> {
  getStepsAndCount = (section: SetupSections) => {
    const {customiseSteps, communicateSteps, inviteSteps} = this.props
    switch (section) {
      case SetupSections.CUSTOMISE:
        return {steps: customiseSteps, startingStepCount: 1}
      case SetupSections.COMMUNICATE:
        return {steps: communicateSteps, startingStepCount: customiseSteps.length + 1}
      case SetupSections.INVITE:
        return {steps: inviteSteps, startingStepCount: communicateSteps.length + customiseSteps.length + 1}
    }
  }

  render() {
    return (
      <>
        <NavSection title="setup_tenant.navigation.section.title.customise" {...this.getStepsAndCount(SetupSections.CUSTOMISE)} />
        <NavSection title="setup_tenant.navigation.section.title.communicate" {...this.getStepsAndCount(SetupSections.COMMUNICATE)} />
        <NavSection title="setup_tenant.navigation.section.title.invite" {...this.getStepsAndCount(SetupSections.INVITE)} />
      </>
    )
  }
}

export default Navigation
